export default __webpack_public_path__ + "static/media/thanks.8e9d99fe.jpg";